<script lang="ts" context="module">
  export enum PieceRotation {
    Deg0,
    Deg90,
    Deg180,
    Deg270,
  }

  export enum PieceTypes {
    Dot = "Dot",
    O = "O",
    I = "I",
    T = "T",
    L = "L",
    J = "J",
    Z = "Z",
    S = "S",
  }
</script>
